/** Helpers compartidos por las páginas /staff/usage. */

export function formatUsd(amount: number): string {
  // Costos del LLM frecuentemente son centavos pequeños ($0.0287). Mostramos
  // hasta 4 decimales — Intl recorta ceros a la derecha respetando el mínimo.
  // Para montos ≥ $1 con 4 ceros, el resultado es indistinguible de 2 decimales
  // ($1.00 vs $1.0000) — bajamos el máximo a 2 ahí para no ensuciar la tabla.
  const fractionDigits = Math.abs(amount) >= 1 ? 2 : 4;
  return new Intl.NumberFormat('en-US', {
    style: 'currency',
    currency: 'USD',
    minimumFractionDigits: fractionDigits,
    maximumFractionDigits: fractionDigits,
  }).format(amount);
}

export function fmtDate(iso: string | null | undefined): string | null {
  if (!iso) return null;
  try {
    return new Date(iso).toLocaleDateString('es-MX', { year: 'numeric', month: 'short', day: 'numeric' });
  } catch {
    return null;
  }
}

export function fmtMonth(iso: string): string {
  try {
    return new Date(iso).toLocaleDateString('es-MX', { year: 'numeric', month: 'short' });
  } catch {
    return iso;
  }
}

export function fmtDateTime(iso: string | null | undefined): string | null {
  if (!iso) return null;
  try {
    return new Date(iso).toLocaleString('es-MX');
  } catch {
    return null;
  }
}

/**
 * Convierte `YYYY-MM-DD` (de un Input type=date) a un timestamp ISO con UTC.
 * `start` = 00:00:00.000Z; `end` = 23:59:59.999Z. Si la entrada ya es ISO, la
 * devuelve tal cual.
 */
export function monthRangeFromInput(input: string, kind: 'start' | 'end'): string {
  if (!input) return new Date().toISOString();
  if (input.includes('T')) return input;
  const d = new Date(`${input}T${kind === 'start' ? '00:00:00.000Z' : '23:59:59.999Z'}`);
  return d.toISOString();
}

/** ISO `YYYY-MM-DDT23:59:59.999Z` para "ahora". */
export function todayIsoEndOfDay(): string {
  const d = new Date();
  d.setUTCHours(23, 59, 59, 999);
  return d.toISOString();
}

/** ISO del 1° del mes hace `n` meses (00:00 UTC). */
export function monthsAgoIso(n: number): string {
  const d = new Date();
  d.setUTCMonth(d.getUTCMonth() - n, 1);
  d.setUTCHours(0, 0, 0, 0);
  return d.toISOString();
}
